// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.3.0
//   protoc               v5.27.3
// source: confidence/flags/types/v1/types.proto
/* eslint-disable */
import { BinaryReader, BinaryWriter } from '@bufbuild/protobuf/wire';
export const protobufPackage = 'confidence.flags.types.v1';
function createBaseFlagSchema() {
    return {
        structSchema: undefined,
        listSchema: undefined,
        intSchema: undefined,
        doubleSchema: undefined,
        stringSchema: undefined,
        boolSchema: undefined,
    };
}
export const FlagSchema = {
    encode(message, writer = new BinaryWriter()) {
        if (message.structSchema !== undefined) {
            FlagSchema_StructFlagSchema.encode(message.structSchema, writer.uint32(10).fork()).join();
        }
        if (message.listSchema !== undefined) {
            FlagSchema_ListFlagSchema.encode(message.listSchema, writer.uint32(18).fork()).join();
        }
        if (message.intSchema !== undefined) {
            FlagSchema_IntFlagSchema.encode(message.intSchema, writer.uint32(26).fork()).join();
        }
        if (message.doubleSchema !== undefined) {
            FlagSchema_DoubleFlagSchema.encode(message.doubleSchema, writer.uint32(34).fork()).join();
        }
        if (message.stringSchema !== undefined) {
            FlagSchema_StringFlagSchema.encode(message.stringSchema, writer.uint32(42).fork()).join();
        }
        if (message.boolSchema !== undefined) {
            FlagSchema_BoolFlagSchema.encode(message.boolSchema, writer.uint32(50).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFlagSchema();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.structSchema = FlagSchema_StructFlagSchema.decode(reader, reader.uint32());
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.listSchema = FlagSchema_ListFlagSchema.decode(reader, reader.uint32());
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.intSchema = FlagSchema_IntFlagSchema.decode(reader, reader.uint32());
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.doubleSchema = FlagSchema_DoubleFlagSchema.decode(reader, reader.uint32());
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.stringSchema = FlagSchema_StringFlagSchema.decode(reader, reader.uint32());
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.boolSchema = FlagSchema_BoolFlagSchema.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            structSchema: isSet(object.structSchema) ? FlagSchema_StructFlagSchema.fromJSON(object.structSchema) : undefined,
            listSchema: isSet(object.listSchema) ? FlagSchema_ListFlagSchema.fromJSON(object.listSchema) : undefined,
            intSchema: isSet(object.intSchema) ? FlagSchema_IntFlagSchema.fromJSON(object.intSchema) : undefined,
            doubleSchema: isSet(object.doubleSchema) ? FlagSchema_DoubleFlagSchema.fromJSON(object.doubleSchema) : undefined,
            stringSchema: isSet(object.stringSchema) ? FlagSchema_StringFlagSchema.fromJSON(object.stringSchema) : undefined,
            boolSchema: isSet(object.boolSchema) ? FlagSchema_BoolFlagSchema.fromJSON(object.boolSchema) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.structSchema !== undefined) {
            obj.structSchema = FlagSchema_StructFlagSchema.toJSON(message.structSchema);
        }
        if (message.listSchema !== undefined) {
            obj.listSchema = FlagSchema_ListFlagSchema.toJSON(message.listSchema);
        }
        if (message.intSchema !== undefined) {
            obj.intSchema = FlagSchema_IntFlagSchema.toJSON(message.intSchema);
        }
        if (message.doubleSchema !== undefined) {
            obj.doubleSchema = FlagSchema_DoubleFlagSchema.toJSON(message.doubleSchema);
        }
        if (message.stringSchema !== undefined) {
            obj.stringSchema = FlagSchema_StringFlagSchema.toJSON(message.stringSchema);
        }
        if (message.boolSchema !== undefined) {
            obj.boolSchema = FlagSchema_BoolFlagSchema.toJSON(message.boolSchema);
        }
        return obj;
    },
};
function createBaseFlagSchema_StructFlagSchema() {
    return { schema: {} };
}
export const FlagSchema_StructFlagSchema = {
    encode(message, writer = new BinaryWriter()) {
        Object.entries(message.schema).forEach(([key, value]) => {
            FlagSchema_StructFlagSchema_SchemaEntry.encode({ key: key, value }, writer.uint32(10).fork()).join();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFlagSchema_StructFlagSchema();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    const entry1 = FlagSchema_StructFlagSchema_SchemaEntry.decode(reader, reader.uint32());
                    if (entry1.value !== undefined) {
                        message.schema[entry1.key] = entry1.value;
                    }
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            schema: isObject(object.schema)
                ? Object.entries(object.schema).reduce((acc, [key, value]) => {
                    acc[key] = FlagSchema.fromJSON(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.schema) {
            const entries = Object.entries(message.schema);
            if (entries.length > 0) {
                obj.schema = {};
                entries.forEach(([k, v]) => {
                    obj.schema[k] = FlagSchema.toJSON(v);
                });
            }
        }
        return obj;
    },
};
function createBaseFlagSchema_StructFlagSchema_SchemaEntry() {
    return { key: '', value: undefined };
}
export const FlagSchema_StructFlagSchema_SchemaEntry = {
    encode(message, writer = new BinaryWriter()) {
        if (message.key !== '') {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== undefined) {
            FlagSchema.encode(message.value, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFlagSchema_StructFlagSchema_SchemaEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.value = FlagSchema.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : '',
            value: isSet(object.value) ? FlagSchema.fromJSON(object.value) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== '') {
            obj.key = message.key;
        }
        if (message.value !== undefined) {
            obj.value = FlagSchema.toJSON(message.value);
        }
        return obj;
    },
};
function createBaseFlagSchema_DoubleFlagSchema() {
    return {};
}
export const FlagSchema_DoubleFlagSchema = {
    encode(_, writer = new BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFlagSchema_DoubleFlagSchema();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
};
function createBaseFlagSchema_IntFlagSchema() {
    return {};
}
export const FlagSchema_IntFlagSchema = {
    encode(_, writer = new BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFlagSchema_IntFlagSchema();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
};
function createBaseFlagSchema_StringFlagSchema() {
    return {};
}
export const FlagSchema_StringFlagSchema = {
    encode(_, writer = new BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFlagSchema_StringFlagSchema();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
};
function createBaseFlagSchema_BoolFlagSchema() {
    return {};
}
export const FlagSchema_BoolFlagSchema = {
    encode(_, writer = new BinaryWriter()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFlagSchema_BoolFlagSchema();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
};
function createBaseFlagSchema_ListFlagSchema() {
    return { elementSchema: undefined };
}
export const FlagSchema_ListFlagSchema = {
    encode(message, writer = new BinaryWriter()) {
        if (message.elementSchema !== undefined) {
            FlagSchema.encode(message.elementSchema, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFlagSchema_ListFlagSchema();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.elementSchema = FlagSchema.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return { elementSchema: isSet(object.elementSchema) ? FlagSchema.fromJSON(object.elementSchema) : undefined };
    },
    toJSON(message) {
        const obj = {};
        if (message.elementSchema !== undefined) {
            obj.elementSchema = FlagSchema.toJSON(message.elementSchema);
        }
        return obj;
    },
};
function isObject(value) {
    return typeof value === 'object' && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=types.js.map